import styled from 'styled-components';

export const PageContainer = styled.div`
	min-height: 100dvh;
	display: grid;
	place-items: center;
	padding: 24px;
`;

export const StyledCard = styled.div`
	max-width: 400px;
	width: 100%;
	padding: 24px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
	border-radius: 16px;
	background: #fff;
`;

export const Title = styled.h1`
	text-align: center;
	margin-bottom: 16px;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const PasswordInput = styled.input`
	padding: 10px;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	font-size: 16px;
`;

export const ErrorText = styled.p`
	color: #c62828;
	margin-top: 8px;
	text-align: center;
`;
